import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '../PendingsCard';
import ExpiringRentContainer from './ExpiringRentContainer';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getExpiringRentProperties } from '@/store/slices/components/dashboard/service';
import { getPropertiesSearchParams } from '../utils';
import ExpiringRentEmptyState from './ExpiringRentEmptyState';
import { PROPERTIES_STATUS } from '../../constants';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function ExpiringRent() {
  const dispatch = useDispatch();
  const { count, loading, hasFetched, empty } = useSelector(
    (state) => state.DashboardSlice.expiringRentProperties
  );
  const track = useTrackPendingTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');

  useFetchOnViewport(
    (query) => {
      dispatch(getExpiringRentProperties(query));
    },
    [],
    { hasFetched }
  );

  const eventText = `${count} ${Trans(
    translations,
    count === 1 ? 'RentToExpire' : 'RentsToExpire'
  )}`;
  const searchParams = getPropertiesSearchParams({
    statusId: PROPERTIES_STATUS.NOT_AVAILABLE,
    operation_types: [2],
    current_localization_id: '0',
  });

  const urlRedirect = `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={empty ? null : urlRedirect}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.expiringRent(element)}
      >
        {eventText}
      </PendingCard.Header>
      {empty ? (
        <ExpiringRentEmptyState />
      ) : (
        <ExpiringRentContainer
          trackCallback={(element) => track.expiringRent(element)}
        />
      )}
    </PendingCard>
  );
}

export default ExpiringRent;
